import { createFileRoute } from '@tanstack/react-router'

import { anyOfPermissions } from '@orus.eu/right-access-management'

import { PendingSubscriptionPaymentPage } from '../../../../../components/pages/backoffice/common/backoffice-pending-subscriptions/pending-subscription-payment-page.tsx'
import { PermissionChecker } from '../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/subscriptions/$subscriptionId/payment')({
  component: function Compoonent() {
    const { subscriptionId } = Route.useParams()

    return (
      <PermissionChecker requiredPermissions={[anyOfPermissions('contract.sign', 'contract.sign.relatedOnly')]}>
        <PendingSubscriptionPaymentPage subscriptionId={subscriptionId} />
      </PermissionChecker>
    )
  },
})
